export const initialState = {
    cartItems: [],
};
